import { useTranslation } from "react-i18next";
import {
  StageShell, ColumnHeader, Metric, NumField, SliderBlock,
} from "./primitives";

export default function Stage1Landlord({
  annualNet, setAnnualNet,
  yearsOffered, setYearsOffered,
  investorDiscount, setInvestorDiscount,
  calc, fmtM, currencyCode,
}) {
  const { t } = useTranslation();

  return (
    <StageShell
      step={t("jc1_step")}
      role={t("jc1_role")}
      title={t("jc1_title")}
      desc={t("jc1_desc")}
      accentBg="bg-black"
      accentText="text-[#FFCC00]"
    >
      <div className="grid grid-cols-12 gap-6 mt-6">
        <div className="col-span-12 md:col-span-5">
          <ColumnHeader label={t("jc_stage_in")} accent="text-zinc-700" />
          <div className="space-y-5 border border-black/10 bg-white p-5">
            <NumField
              id="netannual"
              label={`${t("jc1_in_net_annual")} (${currencyCode})`}
              tip={t("tip_net_annual")}
              value={annualNet}
              step={1000}
              min={0}
              onChange={setAnnualNet}
              suffix={currencyCode}
            />
            <SliderBlock
              id="years"
              label={t("jc1_in_years")}
              tip={t("tip_years")}
              valueLabel={`${yearsOffered} yr · ${yearsOffered * 12} ${t("months")}`}
              value={yearsOffered}
              min={1}
              max={20}
              step={1}
              onChange={setYearsOffered}
            />
            <SliderBlock
              id="disc"
              label={t("jc1_in_discount")}
              tip={t("tip_discount")}
              valueLabel={`${investorDiscount.toFixed(0)}%`}
              value={investorDiscount}
              min={5}
              max={50}
              step={1}
              onChange={setInvestorDiscount}
            />
          </div>
        </div>

        <div className="col-span-12 md:col-span-7">
          <ColumnHeader label={t("jc_stage_out")} accent="text-[#002FA7]" />
          <div className="grid grid-cols-1 gap-px bg-black/10 border border-black/10">
            <div className="bg-white p-5">
              <Metric
                k={t("jc1_out_total")}
                v={fmtM(calc.totalFutureNet, 0)}
                big
                tip={t("tip_total_net")}
              />
            </div>
            <div className="bg-black text-white p-5">
              <Metric
                k={t("jc1_out_landlord_today")}
                v={fmtM(calc.landlordNetToday, 0)}
                accent="text-[#FFCC00]"
                big
                tip={t("tip_landlord_today")}
              />
            </div>
            <div className="bg-white p-5">
              <Metric
                k={t("jc1_out_discount")}
                v={`+ ${fmtM(calc.totalInvestorDiscount, 0)}`}
                accent="text-[#16A34A]"
                tip={t("tip_discount_total")}
              />
            </div>
          </div>
        </div>
      </div>
    </StageShell>
  );
}
